import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "./Reveal";

const STATS = [
  { id: "new-logos", label: "Net New Logo Per Year", value: 25, suffix: "+" },
  { id: "projects", label: "Completed Projects", value: 30, suffix: "+" },
  { id: "years", label: "Years of Experience", value: 3, suffix: "+" },
  { id: "team", label: "Team Strength", value: 50, suffix: "+" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const dur = 1600;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setN(Math.round((1 - Math.pow(1 - p, 3)) * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);
  return (
    <span ref={ref}>
      {n}
      <span className="text-smipl-orange">{suffix}</span>
    </span>
  );
};

const StatsBand = () => (
  <section data-testid="stats-band" className="relative border-y border-white/8 bg-navy-dark/30">
    <div className="max-w-6xl mx-auto px-6 py-16 md:py-20 grid grid-cols-2 lg:grid-cols-4 gap-10">
      {STATS.map((s, i) => (
        <Reveal key={s.id} delay={i * 0.08}>
          <div data-testid={`stat-${s.id}`} className="text-center lg:text-left">
            {s.value != null ? (
              <p className="font-display text-5xl md:text-6xl font-extrabold tracking-tight text-white">
                <Counter value={s.value} suffix={s.suffix} />
              </p>
            ) : (
              <p className="font-display text-2xl md:text-3xl font-bold tracking-tight text-white leading-tight lg:min-h-[60px] flex items-center justify-center lg:justify-start">
                {s.line}
              </p>
            )}
            <p className="mt-3 font-mono text-[11px] tracking-[0.25em] uppercase text-slate-500">{s.label}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default StatsBand;
